import {
  type HistoryGroup,
  getHistoryId,
  isHistoryGroup,
} from "@/features/history/utils";
import { useModals } from "@/features/modals/hooks";
import { getTaskUpdateDetail } from "@/features/tasks/utils";
import { type History, type Opportunity, useTasks } from "@repo/api";
import { Text } from "@repo/skapa";
import { useTranslation } from "@repo/translation";
import { translateAsKey, useSettings } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

import { HistoryListViewItem } from "./HistoryListViewItem";

interface Props {
  history: History | HistoryGroup;
  opportunity: Opportunity;
}

export const TaskHistoryItem = ({ history, opportunity }: Props) => {
  const { pushModal } = useModals();
  const { dateFnsLocale } = useTranslation();
  const { language, task_configuration } = useSettings();
  const entryId = getHistoryId(history);
  const { data: tasks = [] } = useTasks({
    opportunityId: String(opportunity.id),
  });
  const task = tasks.find((item) => item.id === Number(entryId));

  const historyEntries = isHistoryGroup(history)
    ? history.prevEntries
    : undefined;

  return (
    <HistoryListViewItem
      history={history}
      control={task ? "navigational" : "default"}
      onClick={() => {
        if (task) {
          pushModal({
            type: "TASK",
            task,
            historyEntries,
            context: "PROJECT",
          });
        }
        trackAnalytics("task_history");
      }}
      title={translateAsKey(history.details?.task_title) ?? history.title}
      description={
        <>
          {getTaskUpdateDetail(
            language,
            history,
            dateFnsLocale,
            task_configuration?.task_types
          )?.description?.map((el, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Text key={i} textStyle="Body.S">
              {el}
            </Text>
          ))}
          <Text textStyle="Body.S">{history.note}</Text>
        </>
      }
    />
  );
};
